import { render } from "./PageWrapper.vue?vue&type=template&id=e2999c48"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__